/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseData interface.
 */
export function instanceOfFxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseData(value) {
    if (!('AccessToken' in value) || value['AccessToken'] === undefined)
        return false;
    if (!('RefreshToken' in value) || value['RefreshToken'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseDataFromJSON(json) {
    return FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseDataFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AccessToken': json['AccessToken'],
        'RefreshToken': json['RefreshToken'],
    };
}
export function FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseDataToJSON(json) {
    return FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseDataToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AccessToken': value['AccessToken'],
        'RefreshToken': value['RefreshToken'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerResponseData.js.map